import React from 'react';
const TableOfContents = () => {
  return <div className="bg-gray-50 p-5 rounded-lg mb-8" data-id="element-461">
      <h3 className="font-bold text-gray-700 mb-4 text-base uppercase tracking-wider" data-id="element-462">
        Table of Contents
      </h3>
      <ul className="space-y-3 text-base" data-id="element-463">
        <li data-id="element-464">
          <a href="#introduction" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-465">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-466"></span>
            Introduction
          </a>
        </li>
        <li data-id="element-467">
          <a href="#discovery" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-468">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-469"></span>
            The Discovery
          </a>
        </li>
        <li data-id="element-470">
          <a href="#how-it-works" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-471">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-472"></span>
            How It Works
          </a>
        </li>
        <li data-id="element-473">
          <a href="#ingredients" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-474">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-475"></span>
            Key Ingredients
          </a>
        </li>
        <li data-id="element-476">
          <a href="#testimonials" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-477">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-478"></span>
            Real Results
          </a>
        </li>
        <li data-id="element-479">
          <a href="#science" className="text-gray-700 hover:text-green-600 transition-colors flex items-center" data-id="element-480">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0" data-id="element-481"></span>
            The Science
          </a>
        </li>
        <li data-id="element-482">
          <a href="#special-offer" className="text-gray-700 hover:text-green-600 transition-colors flex items-center font-medium" data-id="element-483">
            <span className="w-2 h-2 bg-red-500 rounded-full mr-3 flex-shrink-0" data-id="element-484"></span>
            Special Offer
          </a>
        </li>
      </ul>
    </div>;
};
export default TableOfContents;